import { IProfile, ISignInInput, ISignUpInput, IUser, IVerifyUser, ITokenAcceptance } from "../../interfaces/auth.interface";

const ActionTypes = {
  SET_TOKEN: '[Auth] Set Token',

  SET_USER: '[Auth] Set User',

  GET_TOKEN_FROM_LOCAL_STORAGE: '[Auth] Get Token From Local Storage',

  CLEAR_TOKEN: '[Auth] Clear Token',

  GET_USER_INFO: '[Auth] Get User Info',
  GET_USER_INFO_SUCCESS: '[Auth] Get User Info Success',
  GET_USER_INFO_FAIL: '[Auth] Get User Info Fail',

  SIGN_UP: '[Auth] Sign Up',
  SIGN_UP_SUCCESS: '[Auth] Sign Up Success',
  SIGN_UP_FAIL: '[Auth] Sign Up Fail',

  RESEND_VERIFICATION_EMAIL: '[Auth] Resend Verification Email',
  RESEND_VERIFICATION_EMAIL_SUCCESS: '[Auth] Resend Verification Email Success',
  RESEND_VERIFICATION_EMAIL_FAIL: '[Auth] Resend Verification Email Fail',

  VERIFY_EMAIL: '[Auth] Verify Email',
  VERIFY_EMAIL_SUCCESS: '[Auth] Verify Email Success',
  VERIFY_EMAIL_FAIL: '[Auth] Verify Email Fail',

  SIGN_IN: '[Auth] Sign In',
  SIGN_IN_SUCCESS: '[Auth] Sign In Success',
  SIGN_IN_FAIL: '[Auth] Sign In Fail',

  ACCEPT_TERMS: '[Auth] Accept Terms',
  ACCEPT_TERMS_SUCCESS: '[Auth] Accept Terms Success',
  ACCEPT_TERMS_FAIL: '[Auth] Accept',

  RESET_PASSWORD: '[Auth] Reset Password',
  RESET_PASSWORD_SUCCESS: '[Auth] Reset Password Success',
  RESET_PASSWORD_FAIL: '[Auth] Reset Password Fail',

  RESET_PASSWORD_CONFIRM: '[Auth] Reset Password Confirm',
  RESET_PASSWORD_CONFIRM_SUCCESS: '[Auth] Reset Password Confirm Success',
  RESET_PASSWORD_CONFIRM_FAIL: '[Auth] Reset Password Confirm Fail',

  UPDATE_PASSWORD: '[Auth] Update Password',
  UPDATE_PASSWORD_SUCCESS: '[Auth] Update Password Success',
  UPDATE_PASSWORD_FAIL: '[Auth] Update Password Fail',

  UPDATE_USER: '[Auth] Update User',
  UPDATE_USER_SUCCESS: '[Auth] Update User Success',
  UPDATE_USER_FAIL: '[Auth] Update User Fail',

  LOG_OUT: '[Auth] Log Out',
  LOG_OUT_SUCCESS: '[Auth] Log Out Success',
  LOG_OUT_FAIL: '[Auth] Log Out Fail',
};

export class SetToken {
  static type = ActionTypes.SET_TOKEN;

  constructor(public payload: string) {}
}

export class SetUser {
  static type = ActionTypes.SET_USER;

  constructor(public payload: any) {}
}

export class GetTokenFromLocalStorage {
  static type = ActionTypes.GET_TOKEN_FROM_LOCAL_STORAGE;
}

export class ClearToken {
  static type = ActionTypes.CLEAR_TOKEN;
}

export class GetUserInfo {
  static type = ActionTypes.GET_USER_INFO;
}

export class GetUserInfoSuccess {
  static type = ActionTypes.GET_USER_INFO_SUCCESS;

  constructor(public payload: IUser) {}
}

export class GetUserInfoFail {
  static type = ActionTypes.GET_USER_INFO_FAIL;
}

export class SignIn {
  static type = ActionTypes.SIGN_IN;

  constructor(public payload: ISignInInput) {}
}

export class SignInSuccess {
  static type = ActionTypes.SIGN_IN_SUCCESS;

  constructor(public payload: any) {}
}

export class SignInFail {
  static type = ActionTypes.SIGN_IN_FAIL;

  constructor(public payload: any, public metadata: string) {}
}

export class SignUp {
  static type = ActionTypes.SIGN_UP;

  constructor(public payload: ISignUpInput) {}
}

export class SignUpSuccess {
  static type = ActionTypes.SIGN_UP_SUCCESS;

  constructor(public payload: any, public metadata: ISignUpInput) {}
}

export class SignUpFail {
  static type = ActionTypes.SIGN_UP_FAIL;

  constructor(public payload: any) {}
}

export class ResendVerificationEmail {
  static type = ActionTypes.RESEND_VERIFICATION_EMAIL;

  constructor(public payload: string) {}
}

export class ResendVerificationEmailSuccess {
  static type = ActionTypes.RESEND_VERIFICATION_EMAIL_SUCCESS;

  constructor(public payload: any) {}
}

export class ResendVerificationEmailFail {
  static type = ActionTypes.RESEND_VERIFICATION_EMAIL_FAIL;

  constructor(public payload: any) {}
}

export class VerifyEmail {
  static type = ActionTypes.VERIFY_EMAIL;

  constructor(public payload: IVerifyUser) {}
}

export class VerifyEmailSuccess {
  static type = ActionTypes.VERIFY_EMAIL_SUCCESS;

  constructor(public payload: any) {}
}

export class VerifyEmailFail {
  static type = ActionTypes.VERIFY_EMAIL_FAIL;

  constructor(public payload: any) {}
}

export class ResetPassword {
  static type = ActionTypes.RESET_PASSWORD;

  constructor(public payload: string) {}
}

export class ResetPasswordSuccess {
  static type = ActionTypes.RESET_PASSWORD_SUCCESS;

  constructor(public payload: any) {}
}

export class ResetPasswordFail {
  static type = ActionTypes.RESET_PASSWORD_FAIL;

  constructor(public payload: any) {}
}

export class ResetPasswordConfirm {
  static type = ActionTypes.RESET_PASSWORD_CONFIRM;

  constructor(public payload: any) {}
}

export class ResetPasswordConfirmSuccess {
  static type = ActionTypes.RESET_PASSWORD_CONFIRM_SUCCESS;

  constructor(public payload: any) {}
}

export class ResetPasswordConfirmFail {
  static type = ActionTypes.RESET_PASSWORD_CONFIRM_FAIL;

  constructor(public payload: any) {}
}

export class UpdatePassword {
  static type = ActionTypes.UPDATE_PASSWORD;

  constructor(public payload: {password: string, newPassword: string}) {}
}

export class UpdatePasswordSuccess {
  static type = ActionTypes.UPDATE_PASSWORD_SUCCESS;

  constructor(public payload: IUser) {}
}

export class UpdatePasswordFail {
  static type = ActionTypes.UPDATE_PASSWORD_FAIL;
}

export class UpdateUser {
  static type = ActionTypes.UPDATE_USER;

  constructor(public payload: IProfile) {}
}

export class UpdateUserSuccess {
  static type = ActionTypes.UPDATE_USER_SUCCESS;

  constructor(public payload: any, public metadata: IProfile) {}
}

export class UpdateUserFail {
  static type = ActionTypes.UPDATE_USER_FAIL;
}


export class AcceptTerms {
  static type = ActionTypes.ACCEPT_TERMS;
  constructor(public payload: ITokenAcceptance) {}
}
export class AcceptTermsSuccess {
  static type = ActionTypes.ACCEPT_TERMS_SUCCESS;
  constructor(public payload: any, public metadata: ITokenAcceptance) {}
}
export class AcceptTermsFail {
  static type = ActionTypes.ACCEPT_TERMS_FAIL;
}


export class LogOut {
  static type = ActionTypes.LOG_OUT;
}

export class LogOutSuccess {
  static type = ActionTypes.LOG_OUT_SUCCESS;

  constructor(public payload: any) {}
}

export class LogOutFail {
  static type = ActionTypes.LOG_OUT_FAIL;

  constructor(public payload: any) {}
}
